import { Component, Input } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
/**
 * Generated class for the SelectorPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-selector-popover',
  templateUrl: 'selector-popover.html',
  styleUrls: ['./selector-popover.scss'],
  standalone: false,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule
  ]
})
export class SelectorPopoverPage {
  public static PATH: string = 'selectpopover';

  @Input() items: Array<any>;
  @Input() selectedItem: any;

  constructor(
    public viewCtrl: ModalController,
    private events: AppEventService) {
      console.log("selector-popover - constructor");

//      this.items = navParams.data.items;
//      this.selectedItem = navParams.data.selectedItem;

      console.log("SelectorPopoverPage: selected item = " + this.selectedItem)
  }

  onSelectItem(item: any) {
    console.log('selector-popover - selected item: ' + item);
    this.selectedItem = item;
    this.events.publish("item:selected", item);
    this.viewCtrl.dismiss();
  }
}
